<template>
    <div id="app">
      <yetkidialog ref="yetkidialog"></yetkidialog>
      <hatadialog ref="hatadialog"></hatadialog>
      <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
  
      <v-app id="inspire" light>
        <v-card color="grey lighten-5" flat>
          <v-layout row wrap>
            <v-flex xs12 md12 sm12>
              <v-toolbar size="120px" dark color="info">
                <v-toolbar-title> Paket Ek Hizmetler </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field
                  flat=""
                  solo-inverted=""
                  hide-details
                  v-model="searchara"
                  :label="$t('Search')"
                  append-icon="search"
                  @click:append="getList"
                  v-on:keyup.13="getList()"
                >
                </v-text-field>
  
                <v-btn class="white--text" flat @click="openEkHizmetAddDialog()">
                  <span class="hidden-sm-and-down">{{ $t('Add-v2', { value: "Ek Hizmet"}) }} </span>
                  <v-icon right dark>add</v-icon>
                </v-btn>
              </v-toolbar>
            </v-flex>
  
            <v-container fluid>
              <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md12 pb-3>
                    <v-card flat class="white--text">
                      <v-card flat>
                        <v-card-actions>
                          <v-layout row wrap>
                            <v-flex xs12 sm12>
                              <v-card flat>
                                <v-data-table
                                  :headers="headersadres"
                                  :rows-per-page-items="[50]"
                                  :items="ekhizmetler"
                                  :expand="expand"
                                  item-key="Id"
                                >
                                  <template slot="items" slot-scope="props">
                                    <tr item>
                                      <td>
                                        <v-btn
                                          v-if="props.item.Fiyatlar.length > 0"
                                          fab
                                          icon
                                          small
                                          @click="
                                            props.expanded = !props.expanded
                                          "
                                        >
                                          <v-icon align-center
                                            >expand_more</v-icon
                                          >
                                        </v-btn>
                                      </td>
                                      <td class="text-xs-left">
                                        {{ props.item.Id }}
                                      </td>
                                      <td class="text-xs-left">
                                        {{ props.item.Isim }}
                                      </td>
                                      <td class="text-xs-left">
                                        {{ props.item.Aciklama }}
                                      </td>
                                      <td
                                        class="
                                          justify-end
                                          align-center
                                          full-heigth
                                          layout
                                          px-0
                                        "
                                      >
                                        <v-tooltip bottom>
                                          <v-btn
                                            icon
                                            small
                                            slot="activator"
                                            flat
                                            @click="
                                              openEkHizmetUpdateDialog(props.item)
                                            "
                                          >
                                            <v-icon color="green"
                                              >system_update_alt</v-icon
                                            >
                                          </v-btn>
                                          <span>{{ $t('Update') }}</span>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                          <v-btn
                                            icon
                                            small
                                            slot="activator"
                                            flat
                                            @click="openFiyat(props.item)"
                                          >
                                            <v-icon color="indigo"
                                              >meeting_room</v-icon
                                            >
                                          </v-btn>
                                          <span>Alt Oda Tipi Ekle</span>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                          <v-btn
                                            @click="deleteRoomType(props.item)"
                                            icon
                                            small
                                            slot="activator"
                                            flat
                                          >
                                            <v-icon color="error">delete</v-icon>
                                          </v-btn>
                                          <span> {{  $t('Delete') }} </span>
                                        </v-tooltip>
                                      </td>
                                    </tr>
                                  </template>
  
                                  <template v-slot:expand="props">
                                    <v-card
                                      flat
                                      v-if="props.item.Fiyatlar != null"
                                    >
                                      <v-card-text>
                                        <v-data-table
                                          :headers="headersadresLower"
                                          :rows-per-page-items="[50]"
                                          :items="props.item.Fiyatlar"
                                          hide-actions
                                          class="elevation-1 red"
                                        >
                                          <template
                                            slot="items"
                                            slot-scope="props"
                                          >
                                            <tr item>
                                              <td class="text-xs-left">
                                                {{ props.item.Fiyat }}
                                              </td>
                                              <td class="text-xs-left">
                                                {{ props.item.ParaBirimi }}
                                              </td>
                                              <td
                                                class="
                                                  justify-end
                                                  align-center
                                                  full-heigth
                                                  layout
                                                  px-0
                                                "
                                              >
                                                <v-tooltip bottom>
                                                  <v-btn
                                                    icon
                                                    small
                                                    slot="activator"
                                                    flat
                                                    @click="
                                                      openUpdateFiyat(
                                                        props.item
                                                      )
                                                    "
                                                  >
                                                    <v-icon color="green"
                                                      >system_update_alt</v-icon
                                                    >
                                                  </v-btn>
                                                  <span>{{ $t('Update') }}</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                  <v-btn
                                                    @click="
                                                      deleteRoomType(props.item)
                                                    "
                                                    icon
                                                    small
                                                    slot="activator"
                                                    flat
                                                  >
                                                    <v-icon color="error"
                                                      >delete</v-icon
                                                    >
                                                  </v-btn>
                                                  <span> {{ $t('Delete') }} </span>
                                                </v-tooltip>
                                              </td>
                                            </tr>
                                          </template>
                                        </v-data-table>
                                      </v-card-text>
                                    </v-card>
                                    <v-card v-else>
                                      <v-card-text>
                                        {{ $t('Recorded-Room-Type-not-Found') }}
                                      </v-card-text>
                                    </v-card>
                                  </template>
                                </v-data-table>
                              </v-card>
                            </v-flex>
                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-container>
  
            <v-dialog v-model="addEkHizmetDialog" max-width="450px">
              <v-card flat color="grey lighten-4">
                <v-card-title
                  v-if="isUpdateRoomType"
                  primary-title
                  background-color="primary"
                >
                  Ek Hizmet Güncelle
                </v-card-title>
                <v-card-title v-else primary-title background-color="primary">
                  {{ $t('Add-v2', { value: 'Ek Hizmet'}) }}  
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md6>
                      <v-text-field
                        label="Isim"
                        v-model="ekhizmet.Isim"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md6>
                      <v-text-field
                        :label="$t('Description')"
                        v-model="ekhizmet.Aciklama"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="info"
                    flat="flat"
                    @click.native="addEkHizmetDialog = false"
                    >{{ $t("cancel_button") }}</v-btn
                  >
                  <v-btn
                    v-if="isUpdateRoomType"
                    color="info"
                    flat
                    @click="ekhizmetSave()"
                    >Guncelle</v-btn
                  >
                  <v-btn v-else color="info" flat @click="ekhizmetSave()"
                    >Kaydet</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
  
            <v-dialog v-model="addFiyatDialog" max-width="450px">
              <v-card flat color="grey lighten-4">
                <v-card-title
                  v-if="isUpdateLowerRoomType"
                  primary-title
                  background-color="primary"
                >
                  Fiyat Güncelle
                </v-card-title>
                <v-card-title v-else primary-title background-color="primary">
                  Fiyat Ekle
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md12> </v-flex>
                    <v-flex xs12 sm12 md6>
                      <v-text-field
                        label="Fiyat"
                        v-model="selectedekhizmetfiyat.Fiyat"
                        :disabled="isUpdateLowerRoomType"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md6>
                        <v-select hide-details v-model="selectedekhizmetfiyat.ParaBirimi" :items="dovizItems"
                :rules="[(v) => !!v || $t('Mandatory-section')]" item-text="Title" item-value="DovizKod"
                :label="$t('Currency-Unit')"></v-select>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="info"
                    flat="flat"
                    @click.native="addFiyatDialog = false"
                    >{{ $t("cancel_button") }}</v-btn
                  >
                  <v-btn
                    color="info"
                    v-if="isUpdateLowerRoomType"
                    flat
                    @click="ekhizmetSave()"
                    >{{ $t('Update') }}</v-btn
                  >
                  <v-btn color="info" v-else flat @click="ekhizmetUpdate()"
                    >{{ $t('save_button') }}</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-layout>
        </v-card>
      </v-app>
    </div>
  </template>
  
  
  <script>
  import tarihcomp from "../../customcomp/tarihim";
  import helpers from "@/components/app/customcomp/helpers.js";
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
  import tool from "../../coper/tools";
  import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
  import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
  import auth from '../../../../api/auth'

  export default {
    data() {
      return {
        isUpdateLowerRoomType: false,
        isUpdateRoomType: false,
        expand: false,
        ekhizmetler:[],
        ekhizmet:{
            Id:0,
            Isim:null,
            Aciklama:null,
            Fiyatlar:[]
        },
        selectedekhizmetfiyat:{
            EkHizmetId:0,
            Id:0,
            Fiyat:0,
            ParaBirimi:''
        },
        searchara: null,
        addEkHizmetDialog: false,
        addFiyatDialog: false,
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        headersadres: [
        {
            text: 'Fiyatlar',
            value: "Id",
            width: "20%",
            align: "left",
            sortable: false,
          },
        {
            text: 'Id',
            value: "Id",
            width: "20%",
            align: "left",
            sortable: false,
          },
          {
            text: "İsim",
            value: "Isim",
            width: "20%",
            align: "left",
            sortable: false,
          },
          {
            text: this.$t('Description'),
            value: "Aciklama",
            width: "75%",
            align: "left",
            sortable: false,
          }
        ],
        headersadresLower: [
         {
            text: 'Fiyat',
            value: "Aciklama",
            width: "20%",
            align: "left",
          },
          {
            text: 'Para Birimi',
            value: "ParaBirimi",
            width: "10%",
            align: "left",
          },

        ],
        valid: true,
        items: [],
        tooltip: false,
        el: null,
        ekhizmetler: [],
        snackbar: false,
        text1: "",
        credentials:null,
        dovizItems:[]
      };
    },
    beforeRouteEnter(to, from, next) {
      next((vm) => {
        vm.prevRoute = from.path;
      });
    },
    beforeMount: beforeMount,
    mounted() {
      this.sayfayetki = helpers.pageScreenAuth("coper-tanitimlar-parametrelist");
      this.credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.getParaBirimleri();
      if (this.sayfayetki.Status == true) {
        this.getList();
      } else {
        this.$refs.yetkidialog
          .open(this.sayfayetki.Message, this.sayfayetki.islem)
          .then((sonuc) => {
            if (sonuc == true) {
              if (this.prevRoute != null) {
                var url = "#" + this.prevRoute;
  
                window.open(url, "_self");
              } else {
                var urlMain = "#/";
                window.open(urlMain, "_self");
              }
            }
          });
      }
    },
    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },
  
      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      },
    },
  
    components: {
      tarihcomp: tarihcomp,
      yetkidialog,
      hatadialog,
      snackbarcomp,
    },
    methods: {
        openUpdateFiyat(val) {
        this.selectedekhizmetfiyat = val;
      },
      openEkHizmetAddDialog() {
        this.ekhizmet = {
            Id:0,
            Isim:'',
            Aciklama:'',
            Fiyatlar:[]
        };
        this.addEkHizmetDialog = true;
      },
      openEkHizmetUpdateDialog(val) {
        this.ekhizmet = val;
        this.addEkHizmetDialog;
      },

      openFiyat(val) {
        this.ekhizmet = val;
        this.selectedekhizmetfiyat.EkHizmetId = val.Id;
        this.addFiyatDialog = true;
      },
      ekhizmetSave() {
        let params = {
          Isim : this.ekhizmet.Isim,
          Aciklama: this.ekhizmet.Aciklama
        };
  
        tool.http_post(this, "PaketEkHizmetInsert", params).then(
          (response) => {
            if (response.body.Status == true) {
              this.addEkHizmetDialog = false;
              this.getList();
            } else {
              this.text1 = response.body.ErrorList[0];
              this.snackbar = true;
            }
          },
          (response) => {
           this.text1 = $t('Error-Occured-Please-Try-Again')
            this.snackbar = true;
          }
        );
      },

      ekhizmetUpdate() {
        let params = {
          Id: this.ekhizmet.Id,
          Isim : this.ekhizmet.Isim,
          Aciklama: this.ekhizmet.Aciklama,
          Fiyatlar: this.ekhizmet.Fiyatlar
        };

        if(this.selectedekhizmetfiyat.EkHizmetId === this.ekhizmet.Id && this.selectedekhizmetfiyat.Id < 1){
            params.Fiyatlar.push(this.selectedekhizmetfiyat);
        }
        else if(this.selectedekhizmetfiyat.EkHizmetId === this.ekhizmet.Id && this.selectedekhizmetfiyat.Id > 0){
            var index = params.Fiyatlar.findIndex(x => x.Id == this.selectedekhizmetfiyat.Id);
            if(index > -1){
                params.Fiyatlar[index].Fiyat = this.selectedekhizmetfiyat.Fiyat;
                params.Fiyatlar[index].ParaBirimi = this.selectedekhizmetfiyat.ParaBirimi;
            }
        }
  
        tool.http_post(this, "PaketEkHizmetEdit", params).then(
          (response) => {
            if (response.body.Status == true) {
              this.addEkHizmetDialog = false;
              this.getList();
            } else {
              this.text1 = response.body.ErrorList[0];
              this.snackbar = true;
            }
          },
          (response) => {
           this.text1 = $t('Error-Occured-Please-Try-Again')
            this.snackbar = true;
          }
        );
      },
      
      deleteRoomType(val) {
        let params = {
          Ara: null,
          Id: val.Id,
        };
        tool.http_post(this, "PaketEkHizmetDelete", params).then(
          (response) => {
            if (response.body.Status == true) {
              this.text1 = "Ek Hizmet Silindi";
              this.snackbar = true;
              this.ekhizmetler = response.body.data;
            } else {
              this.text1 = response.body.ErrorList[0];
              this.snackbar = true;
            }
          },
          (response) => {
           this.text1 = $t('Error-Occured-Please-Try-Again')
            this.snackbar = true;
          }
        );
      },
      getParaBirimleri() {
      var params = {
        CompanyCode: this.credentials.SirketKodu,
      };
      this.$http
        .post(auth.API_URL + "api/currency/List", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.dovizItems = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-Döviz";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-Döviz";
              this.snackbar = true;
            }
          }
        );
    },
      git(val) {
        var url = "/#/coper/tanitimlar/adres/id?isl=get&id=" + val.Id;
        window.open(url, "_blank", null, true);
      },
      getList: getList,
    },
  };
  
  function getList() {
    let params = {
      Ara: this.searchara,
    };
    tool.http_post(this, "PaketEkHizmetList", params).then(
      (response) => {
        if (response.body.Status == true) {
          this.ekhizmetler = response.body.data;
        } else {
          this.text1 = response.body.ErrorList[0];
          this.snackbar = true;
        }
      },
      (response) => {
       this.text1 = $t('Error-Occured-Please-Try-Again')
        this.snackbar = true;
      }
    );
  }
  
  function beforeMount() {}
  </script>
  <style>
  </style>